// @ts-check

/**
 * @module dom/Ratecontrol
 */

/**
 *  Delay the execution of the function
 *
 * @export
 * @param {function} callback - Callback function
 * @param {number} wait - Time to wait (in miliseconds) before function is called
 * @param {*} immediate - Call function immediately
 * @returns {function}
 */
export function debounce(callback, wait, immediate) {
    let timeout;

    return function (...args) {
        const callNow = immediate && !timeout;

        window.clearTimeout(timeout);

        timeout = window.setTimeout(() => {
            timeout = null;

            if (!immediate) {
                callback.apply(this, args);
            }
        }, wait);

        if (callNow) {
            callback.apply(this, args);
        }
    };
}

/**
 * Limit the rate at which a function can fire.
 *
 * @export
 * @param {function} callback - Callback function
 * @param {number} thold - Time to wait (in miliseconds)
 * @param {*} scope
 * @returns  {function}
 */
export function throttle(callback, thold, scope) {
    let last;
    let deferTimer;

    const threshold = thold || 250;

    return function (...args) {
        const context = scope || this;
        const now = Number(new Date());

        if (last && now < last + threshold) {
            // Hold on to it
            window.clearTimeout(deferTimer);

            deferTimer = window.setTimeout(() => {
                last = now;
                callback.apply(context, args);
            }, threshold);
        } else {
            last = now;
            callback.apply(context, args);
        }
    };
}
